import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

export const userProfileSchema = z.object({
    FirstName: z.string().min(1, "First name is required"),
    LastName: z.string().min(1, "Last name is required"),
    Email: z.string().email("Valid email is required"),
});

export type UserProfileFormValues = z.infer<typeof userProfileSchema>;

export const userProfileValidation = zodResolver(userProfileSchema);

export const changePasswordSchema = z
    .object({
        CurrentPassword: z.string().min(1, "Current password is required"),
        NewPassword: z
            .string()
            .min(8, "New password must be at least 8 characters"),
        ConfirmPassword: z.string().min(1, "Confirm your new password"),
    })
    .refine((data) => data.NewPassword === data.ConfirmPassword, {
        message: "Passwords do not match",
        path: ["ConfirmPassword"],
    });

export type ChangePasswordFormValues = z.infer<typeof changePasswordSchema>;

export const changePasswordValidation = zodResolver(changePasswordSchema);
